module.exports = __webpack_public_path__ + "img/R-girl.2e7c2e3e.png";